module.exports = __webpack_public_path__ + "img/blog-6.a5b1c9c2.jpg";